import {
  ONBOARDING_MODAL_TITLES,
  MODAL_FIRST_LINE,
  MODAL_SECOND_LINE,
} from "../constant/RegtankOnboarding";
import { useMemo } from "react";

/**
 * Hook to build Regtank Onboarding Modal content
 * Returns modal title and text based on whether user is existing or new
 */
export const useBuildRegtankOnboardModel = (pendingOnBoardingAs?: string) => {
  const isExistingUser = pendingOnBoardingAs === "";
  const modalContent = useMemo(() => {
    if (isExistingUser) {
      return {
        regtankModalTitle: ONBOARDING_MODAL_TITLES.EXISTING_USER,
        regtankFirstLine: MODAL_FIRST_LINE.EXISTING_USER,
        regtankSecLine: MODAL_SECOND_LINE.EXISTING_USER,
      };
    }

    return {
      regtankModalTitle: ONBOARDING_MODAL_TITLES.NEW_USER,
      regtankFirstLine: MODAL_FIRST_LINE.NEW_USER,
      regtankSecLine: MODAL_SECOND_LINE.NEW_USER,
    };
  }, [isExistingUser]);

  return modalContent;
};
